import { render, staticRenderFns } from "./Leiloeiro.vue?vue&type=template&id=3a19f90a"
import script from "./Leiloeiro.vue?vue&type=script&lang=js"
export * from "./Leiloeiro.vue?vue&type=script&lang=js"
import style0 from "../../assets/controlador-v2.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports